export async function generateAIInsight({
  expenses,
  revenue,
  profit,
  roi,
  cpa,
  agentPerformance,
  campaignPerformance,
  activationRate,
  topExpenseCategory,
  topCampaign,
  bestROI,
  worstROI,
  monthlyTrend
}) {
  try {
    // Top Expense Category
    const topCategory = expenses.reduce((acc, exp) => {
      acc[exp.category] = (acc[exp.category] || 0) + Number(exp.amount || 0);
      return acc;
    }, {});

    const topCat = Object.entries(topCategory)
      .sort((a, b) => b[1] - a[1])[0];

    // Top Agent
    const topAgent = [...agentPerformance]
      .sort((a, b) => b.profit - a.profit)[0];

    // Worst Campaign
    const worstCampaign = [...campaignPerformance]
      .sort((a, b) => a.roi - b.roi)[0];

    const totalRevenue = revenue.reduce(
      (sum, r) => sum + Number(r.amount || 0),
      0
    );

    const totalExpense = expenses.reduce(
      (sum, e) => sum + Number(e.amount || 0),
      0
    );
    const API_URL =
      (process.env.REACT_APP_API_URL || "http://localhost:5000").replace(/\/$/, "");
    
        console.log("Using API URL:", API_URL);
    

    const response = await fetch(`${API_URL}/ai`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        prompt: `
You are CFO AI assistant.

Analyze financial KPIs + dashboard charts.

Respond ONLY in this format:

Insight:
(2 short lines max)

Risk:
(1 short line)

Recommendation:
(1-2 short action)

Summary:
Revenue ₹${totalRevenue}
Expense ₹${totalExpense}
Profit ₹${profit}
ROI ${roi}%
CPA ₹${cpa}

Chart KPIs:

Activation Rate: ${activationRate}%
Top Expense Category: ${topExpenseCategory}
Top Campaign Revenue: ${topCampaign}
Best ROI Campaign: ${bestROI}
Worst ROI Campaign: ${worstROI}
Trend: ${monthlyTrend}

Use these KPIs to summarize dashboard charts.
Mention funnel, campaign performance, spend trends.

Extra Context:
Top Category: ${topCat ? topCat[0] + " ₹" + topCat[1] : "None"}
Top Agent: ${topAgent ? topAgent.name + " ₹" + topAgent.profit : "None"}
Weak Campaign: ${worstCampaign ? worstCampaign.name + " ROI " + worstCampaign.roi + "%" : "None"}

Use concise executive language.
No tables.
No raw rows.
No extra text.
`
      }),
    });

    console.log("AI Response Status:", response.status);

    const data = await response.json();

    if (!response.ok) {
      console.error("AI API Error:", data);
      console.error("Error details:", data.details);
      console.error("Full error:", data.fullError);
      throw new Error(data.details || data.error || "API Error");
    }

    console.log("AI Insight Generated:", data.result);
    return data.result;

  } catch (error) {
    console.error("❌ AI Insight Error:", error.message);


    return `
Insight:
Unable to generate AI insight now.

Risk:
AI service unavailable.

Recommendation:
Retry after some time.

Summary:
Dashboard KPIs remain available.
`;
  }
}
